import React from 'react';
import { Expandable } from '@gjensidige/core-expandable';
import { Col, Row } from '@gjensidige/core-grid';
import { Pill } from '@gjensidige/core-pill';
import { useCmsContext } from '@gjensidige/service-cms';

import { AppStep, Step } from '../../types/enums';
import { useCheckListContext } from '../../context/CheckListProvider';
import { checkList } from '../../data/ChekListItems';
import { SecondaryButton } from '../Button';
import styles from './Answers.module.scss';

const Answers = () => {
  const { getText } = useCmsContext();
  const { setCurrentStep, setAppStep, answers } = useCheckListContext();

  const handleClick = (step: Step) => {
    setCurrentStep(step);
    setAppStep(AppStep.CHECKLIST);
  };

  const renderAnswer = (value: string) => {
    if (value === getText('housing.check.faucet.option1')) {
      return <Pill className={styles.bgGreen}>{value}</Pill>;
    } else if (value === getText('housing.check.faucet.option2')) {
      return <Pill className={styles.bgRed}>{value}</Pill>;
    } else return null;
  };

  return (
    <Expandable
      ariaControlId="summary"
      colored={false}
      wrapperClassName={styles.expandable}
    >
      {{
        header: getText('housing.check.summary.answers.title'),
        footer: null,
        content: (
          <>
            {Object.keys(checkList)
              .map((k) => parseInt(k))
              .map((step: Step) => (
                <Row className={styles.summaryRow} key={step}>
                  <Col md={12}>
                    <SecondaryButton
                      noPadding
                      className={styles.summaryTitle}
                      onClick={() => handleClick(step)}
                    >
                      {getText(`${checkList[step].texts}.title`)}
                    </SecondaryButton>
                  </Col>
                  <Col>{renderAnswer(answers[step])}</Col>
                </Row>
              ))}
          </>
        )
      }}
    </Expandable>
  );
};

export default Answers;
